import React from "react";
import store from "../AppState";

const defaultStatuses = {
    1: 'Ledig',
    3: 'Bokad/reserverad',
    2: 'Såld',
    6: 'Säljes senare',
};

export default class StatusLegend extends React.Component {
    render() {
        const statuses = store.data.template_data.statuses || defaultStatuses;

        let counts = {};
        store.data.objects.forEach(object => {
            if (!counts[object.status_id]) {
                counts[object.status_id] = 1;
            } else {
                counts[object.status_id]++;
            }
        });

        const statusElems = Object.keys(statuses).map((i) => {
            let counter = store.data.template_data.legend_counter ? ' (' + (counts[i] ? counts[i] :'0') + ')' : null;
            return <li key={i}><span className={'status-blob status-blob-' + i}></span> {statuses[i]}{counter}</li>
        });

        return (
            <div className="cw-status-legend">
                <ul>
                    {statusElems}
                </ul>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/StatusLegend.jsx